import { ESymbolRoles } from '@Core/Reels/SymbolRoles';
import { GameStore } from '@GameStore/GameStore';
import { EGameStoreKeys } from '@GameStore/GameStoreSchema';

export const getSymbolRoles = (gameStore: GameStore, symbolId: number): ESymbolRoles[] => {
    const configFileSymbolRoles = gameStore.get(EGameStoreKeys.SymbolConfiguration).find((symbolConfiguration) => symbolConfiguration.id === symbolId)?.roles;

    const authenticateResponseSymbolRoles = gameStore
        .get(EGameStoreKeys.AuthenticateGameConfig)
        .symbols[0].find((symbolConfiguration) => symbolConfiguration.symbolId === symbolId);

    if (!authenticateResponseSymbolRoles) {
        return [...(configFileSymbolRoles ?? [])];
    }

    const gameType = gameStore.get(EGameStoreKeys.GameType);
    const specialGameType = gameStore.get(EGameStoreKeys.CurrentSpecialGamesType);

    return (authenticateResponseSymbolRoles.roles ?? []).flatMap((role, index, roles) => {
        if (specialGameType && roles.some((role) => role.specialGameTypes?.includes(specialGameType)) && !role.specialGameTypes?.includes(specialGameType))
            return [];

        const matchesGameType = !role.gameTypes || role.gameTypes.includes(gameType);
        const matchesSpecialGameType = !specialGameType || !role.specialGameTypes || role.specialGameTypes.includes(specialGameType);

        return matchesGameType && matchesSpecialGameType ? role.types : [];
    });
};

export const getSymbolJackpotLevels = (gameStore: GameStore, symbolId: number): number[] => {
    const authenticateResponseSymbolRoles = gameStore
        .get(EGameStoreKeys.AuthenticateGameConfig)
        .symbols[0].find((symbolConfiguration) => symbolConfiguration.symbolId === symbolId);

    const gameType = gameStore.get(EGameStoreKeys.GameType);
    const jackpotLevels: number[] = [];

    if (authenticateResponseSymbolRoles) {
        authenticateResponseSymbolRoles.roles?.forEach((role) => {
            if (!role.gameTypes || role.gameTypes?.includes(gameType)) {
                if (role.jackpotLevel != null) jackpotLevels.push(role.jackpotLevel);
            }
        });
    }

    return jackpotLevels;
};

export const isMultiSymbol = (gameStore: GameStore, symbolId: number): boolean => {
    const possibleComponentSymbolIds = gameStore.get(EGameStoreKeys.Features).multiSymbol?.componentSymbolIdsByMultiSymbolIds.get(symbolId);
    const isMultiSymbol = !!possibleComponentSymbolIds?.some((symbolId) => {
        const symbolRoles = getSymbolRoles(gameStore, symbolId);
        return symbolRoles.includes(ESymbolRoles.LOCK_AND_ROLL_DOUBLE_COIN);
    });
    return isMultiSymbol;
};
